<template>
  <v-card
    @click="modal = true"
    style="position:relative;"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    :class="hover ? 'elevation-10 pointer' : 'elevation-3 pointer'"
  >
    <p
      :class="`${status.class} mb-0 py-1 text-center font-weight-bold`"
      style="font-size:11px;text-transform:uppercase;"
    >
      {{ status.text }}
    </p>
    <v-img :src="item.image" aspect-ratio="2.5"></v-img>
    <span class="discount">
      <h2>-{{ item.discount }}%</h2>
    </span>
    <div class="pa-3" style="position:relative;">
      <p class="mb-0">
        {{ item.service_item.service.name }} |
        {{ item.service_item.description }}
      </p>
      <h3 class="headline primary--text">
        {{ item.title }}
      </h3>
      <h6 class="primary--text mt-2">Solicitud realizada el:</h6>
      <p class="mb-0">
        {{ $moment(item.created_at).format('ddd DD MMM YYYY HH:mm') }}
      </p>
      <template v-if="quoted">
        <h6 class="green--text mt-2">Presupuesto válido hasta el</h6>
        <p class="mb-0">
          {{ $moment(quotation.expires_at).format('ddd DD MMM YYYY HH:mm') }}
        </p>
      </template>
      <template v-else>
      <h6 class="primary--text mt-2">Promoción finaliza el:</h6>
      <p class="mb-0">
        {{ $moment(item.expires_at).format('ddd DD MMM YYYY HH:mm') }}
      </p>
      </template>
    </div>
    <div class="pa-3 primary white--text" style="position:relative;">
      <Estado :quotation="quoted"></Estado>
      <v-container grid-list-xs class="pa-0">
        <v-layout row wrap align-center fill-height>
          <v-flex xs4>
            <img
              id="logo"
              class="elevation-5"
              :src="
                institution.logo
                  ? institution.logo
                  : 'http://placehold.it/200x200'
              "
              alt=""
              style="max-width:100%;"
            />
          </v-flex>
          <v-flex xs8 class="px-0 white--text">
            <h6 class="font-weight-light">Promoción de</h6>
            <h4>{{ institution.name }}</h4>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-dialog v-model="modal" :max-width="status.width" >
      <v-card>
        <template v-if="status.state === 0 && !!quotation">
          <v-card-text>
            <iframe
              :src="quotation.preview"
              style="border:none;width:100%;min-height:400px;"
            ></iframe>
          </v-card-text>
        </template>
        <template v-if="status.state === 1">
          <div class="pa-5 text-center">
            <img src="@/assets/img/we-help-en-espera.png" alt="" />
            <h2 class="headline mt-4 font-weight-light">
              Esta solicitud se encuentra en espera de presupuesto
            </h2>
          </div>
        </template>
        <template v-if="status.state === 2">
          <div class="pa-5 text-center">
            <img src="http://placehold.it/300x300" alt="" />
            <h2 class="headline mt-4 font-weight-light">Esta solicitud ha expirado</h2>
            <p class="mb-0 font-weight-light">
              el {{ $moment(item.expires_at).format('ddd DD MMM YYYY HH:mm') }}
            </p>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    quoted: {
      type: Boolean,
      default: false
    },
    quotation: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Estado: () => import('@/components/panel-data/Estado')
  },
  data() {
    return {
      hover: false,
      modal: false
    }
  },
  computed: {
    institution() {
      return this.item.service_provider.institution
    },
    status() {
      const data = {
        quoted: this.quoted,
        expired: false
      }
      const today = this.$moment()
      const date = this.$moment(this.item.expires_at)
      const diff = date.diff(today, 'days')
      data.expired = diff <= 0
      if (data.quoted)
        return {
          state: 0,
          text: 'Presupuesto Recibido',
          class: 'green white--text',
          width: '800px'
        }
      return {
        state: 1,
        text: 'En Espera de Presupuesto',
        class: 'grey lighten-2',
        width: '500px'
      }
    }
  }
}
</script>
<style scoped>
.discount {
  background-color: red;
  color: white;
  display: inline-block;
  padding: 4px 10px;
  position: absolute;
  top: 40px;
  right: 0;
}
.discount h3 {
  font-weight: 900;
}
#logo {
  max-width: 100%;
  width: 60px;
  border-radius: 100%;
  display: block;
  margin: 0 auto;
}
.pointer {
  cursor: pointer;
}
</style>
